import React, { useRef, useState, useEffect } from "react";
import { Stage, Layer, Image, Line } from "react-konva";
import useImage from "use-image";
import scratchTextureSrc from "./scratch.jpg";
import prizeImgSrc from "./scratchimg.png";
// import logo from "./fabcott.jpg";

const ScratchCard = ({ onScratchComplete }) => {
  const stageRef = useRef(null);
  const [lines, setLines] = useState([]);
  const isScratching = useRef(false);

  // Load images
  const [prizeImage] = useImage(prizeImgSrc);
  const [scratchTexture] = useImage(scratchTextureSrc);

  // Responsive Width & Height (Based on Screen Size)
  const [cardSize, setCardSize] = useState({
    width: window.innerWidth * 0.9,
    height: window.innerHeight * 0.5,
  });

  // Resize listener (To update card size on window resize)
  useEffect(() => {
    const handleResize = () => {
      setCardSize({
        width: window.innerWidth * 0.9,
        height: window.innerHeight * 0.5,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleScratchStart = () => {
    isScratching.current = true;
  };

  const handleScratchMove = (e) => {
    if (!isScratching.current) return;
    const stage = stageRef.current;
    const point = stage.getPointerPosition();
    setLines((prevLines) => [
      ...prevLines,
      {
        points: [...(prevLines.at(-1)?.points || []), point.x, point.y],
        id: Math.random(),
      },
    ]);
  };

  const handleScratchEnd = () => {
    isScratching.current = false;
    if (lines.length > 30) {
      onScratchComplete();
    }
  };

  return (
    <Stage
      ref={stageRef}
      width={cardSize.width}
      height={cardSize.height}
      onMouseDown={handleScratchStart}
      onTouchStart={handleScratchStart}
      onMouseMove={handleScratchMove}
      onTouchMove={handleScratchMove}
      onMouseUp={handleScratchEnd}
      onTouchEnd={handleScratchEnd}
    >
      <Layer>
        {/* Prize Image */}
        {prizeImage && (
          <Image
            image={prizeImage}
            width={cardSize.width}
            height={cardSize.height}
          />
        )}
      </Layer>

      <Layer>
        {/* Scratch Cover */}
        {scratchTexture && (
          <Image
            image={scratchTexture}
            width={cardSize.width}
            height={cardSize.height}
          />
        )}

        {/* Scratch Here Text */}
        {/* <Text
          text="🎉 SCRATCH HERE 🎉"
          fontSize={cardSize.width * 0.07} // Responsive text size
          fontStyle="bold"
          fill="white"
          align="center"
          width={cardSize.width}
          height={cardSize.height}
          verticalAlign="middle"
          shadowColor="black"
          shadowBlur={10}
          shadowOpacity={0.5}
          shadowOffsetX={3}
          shadowOffsetY={3}
          listening={false}
        /> */}

        {/* Scratch Effect */}
        {lines.map((line) => (
          <Line
            key={line.id}
            points={line.points}
            stroke="white"
            strokeWidth={cardSize.width * 0.08} // Responsive stroke size
            tension={0.5}
            lineCap="round"
            globalCompositeOperation="destination-out"
          />
        ))}
      </Layer>
    </Stage>
  );
};

export default ScratchCard;
